import React from 'react';
import { EditableText } from './inline/EditableText';

// Decorative line component with diamond accent
const DecorativeLine = ({ className = '' }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <div className="h-px flex-1 bg-gradient-to-r from-transparent via-amber-500/50 to-transparent"></div>
    <div className="w-2 h-2 rotate-45 bg-amber-500/60"></div>
    <div className="h-px flex-1 bg-gradient-to-r from-transparent via-amber-500/50 to-transparent"></div>
  </div>
);

const PremiumHero = ({ 
  title, 
  subtitle, 
  overline = "World Nuclear Congress 2027",
  children,
  testId = "hero-title",
  editScope,      // Optional: enables inline edit for title/subtitle/overline
}) => {
  const wrap = (path, node) => editScope
    ? <EditableText as="span" scope={{ ...editScope, path }} value={node} multiline={false}>{node}</EditableText>
    : node;
  return (
    <section className="relative bg-gradient-to-br from-[#001428] via-[#001f3f] to-[#001a2e] text-white py-20 md:py-28 overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full opacity-5">
          <div className="absolute top-10 left-10 w-64 h-64 border border-amber-500 rounded-full"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 border border-amber-500 rounded-full"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] border border-amber-500/30 rounded-full"></div>
        </div>
      </div>

      {/* Corner decorations */}
      <div className="absolute top-0 left-0 w-40 h-40 border-l-2 border-t-2 border-amber-500/20"></div>
      <div className="absolute bottom-0 right-0 w-40 h-40 border-r-2 border-b-2 border-amber-500/20"></div>

      <div className="max-w-6xl mx-auto px-6 text-center relative z-10">
        {/* Overline */}
        <p className="text-amber-400 text-sm font-semibold uppercase tracking-[0.3em] mb-4">
          {wrap('hero_subtitle', overline)}
        </p>
        
        {/* Title */}
        <h1 
          className="text-4xl md:text-5xl lg:text-6xl font-serif font-semibold mb-6 leading-tight"
          style={{ fontFamily: "'Playfair Display', serif" }}
          data-testid={testId}
        >
          {wrap('hero_title', title)}
        </h1>
        
        {/* Decorative line */}
        <DecorativeLine className="max-w-md mx-auto mb-6" />
        
        {/* Subtitle */}
        {subtitle && (
          <p className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto font-light leading-relaxed">
            {wrap('hero_tagline', subtitle)}
          </p>
        )}

        {/* Optional additional content */}
        {children && (
          <div className="mt-8">
            {children}
          </div>
        )}
      </div>
    </section>
  );
};

export default PremiumHero;
export { DecorativeLine };
